export default function Hero() {
  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/7ebbb9fec3a8aec74c6f25883165938b.webp"
          alt="Mildred B Cooper Chapel"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 sm:mb-8">
            <div className="w-16 sm:w-24 h-px bg-white/80 mx-auto mb-6 sm:mb-8"></div>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl text-white mb-3 sm:mb-4 tracking-wide drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
              William & Mary
            </h1>
            <div className="w-16 sm:w-24 h-px bg-white/80 mx-auto mt-6 sm:mt-8"></div>
          </div>
          
          <p className="text-white text-lg sm:text-xl md:text-2xl font-light tracking-widest mb-6 sm:mb-8 drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]">
            JUNE 18TH, 2026
          </p>
          
          <p className="text-white text-sm sm:text-base md:text-lg font-light tracking-wide mb-8 sm:mb-12 max-w-2xl mx-auto drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)] px-4">
            Together with their families, William Evan Thieme and Mary Elizabeth Hilton request the honor of your presence at their black-tie wedding ceremony
          </p>
          
          <button
            onClick={() => {
              const element = document.getElementById('rsvp');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-white text-gray-900 px-8 sm:px-10 py-3 sm:py-4 text-xs sm:text-sm tracking-widest font-light hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
          >
            RSVP NOW
          </button>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]"></i>
      </div>
    </section>
  );
}
